import { getCookies, setCookie } from "@crystal/core";
import { MONETATE_ID_COOKIE_KEY } from "./constants.js";
function createRandomRequestId() {
  return Math.floor(Math.random() * Math.floor(999999999)).toString();
}
function extractContryCode(locale) {
  const [, country] = locale.split("_");
  const countryMap = {
    GB: "UK"
  };
  return (countryMap[country] || country).toLowerCase();
}
function generateMonetateDomain({ env, locale, brand }) {
  const countryCode = extractContryCode(locale);
  switch (env) {
    case "stg":
      return `${brand}.${countryCode}.test`;
    case "prod":
      return `${brand}.${countryCode}`;
    case "local":
    case "dev":
    default:
      return `${brand}.glass`;
  }
}
function transformMonetateResponse(rawResponse) {
  const {
    data: { responses }
  } = rawResponse;
  return responses[0].actions;
}
function generateMonetateId() {
  const firstPiece = Math.floor(Math.random() * 6);
  const secondPiece = Math.random().toFixed(9).slice(2);
  const thirdPiece = Date.now().toString();
  return `${firstPiece}.${secondPiece}.${thirdPiece}`;
}
function setMonetateIdCookie() {
  const cookies = getCookies();
  const monetateId = cookies[MONETATE_ID_COOKIE_KEY];
  !monetateId && setCookie(MONETATE_ID_COOKIE_KEY, generateMonetateId());
}
export {
  createRandomRequestId,
  generateMonetateDomain,
  setMonetateIdCookie,
  transformMonetateResponse
};
//# sourceMappingURL=utils.js.map
